/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import EmptySpaceFieldValid from "./EmptySpaceFieldValid";
import CheckValid from "./CheckValid";
import { useSelector, useDispatch } from "react-redux";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import { StartMainCommonLoader, TicketsVerfiyAPI } from "../../redux/actions/adminActions";

const TicketsVerify = (props) => {
    const { ticket_number, MainState, setMainState, error_tickets_number, seterror_tickets_number, showModalNew, setShowModalNew, isMendatory, TicketDetails, setTicketDetails, TicketDetailsLabel } = props;
    const { websocket } = useContext(WebSocketContext);
    const { device_id, tickets_response, commonMainLoader } = useSelector((state) => state.adminReducers);
    const dispatch = useDispatch();
    const exceptThisCostSymbols = ["e", "E", "+", "-", "."];

    // ENTER SEARCH TICKETS 
    const onEnterInvoiceSearch = (e) => {
        const code = e.which || e.keyCode;
        if (code === 13) {
            VerifyTickets();
        };
    };

    // VERIFY TICKTES API CALLING FUNCTION
    const VerifyTickets = async () => {
        if(ticket_number !== "") {
            dispatch(StartMainCommonLoader({
                url: "ticket_search_by_ticket_number",
                loader: true
            }));
            let param = { 
                "transmit": "broadcast", 
                "url": "ticket_search_by_ticket_number",
                "request" : { 
                    "ticket_number" : ticket_number, 
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        } else {
            CheckValid(ticket_number, {type: 'ticket_number', error: seterror_tickets_number})
        };
    };

    useEffect(() => {
        if(Object?.keys(tickets_response)?.length > 0) {
            seterror_tickets_number("");
            if(tickets_response?.status === "SUCCESS") {
                setShowModalNew({
                    ...showModalNew,
                    open: open,
                    title: "Ticket Verification Successful !",
                    subtitle: "Ticket-Verify",
                    description: "",
                    modalType: "Ticket-Verify",
                    button: "",
                    Data: tickets_response
                });

                setTicketDetails({
                    ...TicketDetails,
                    afs_issue: (tickets_response?.data?.cf?.cf_issue === null || tickets_response?.data?.cf?.cf_issue === undefined) ? tickets_response?.data?.cf?.cf_issue_1 : tickets_response?.data?.cf?.cf_issue,
                    afs_issue_type: tickets_response?.data?.cf?.cf_issue_type,
                    afs_product_name: tickets_response?.data?.product?.productName
                });
            } else {
                setShowModalNew({
                    ...showModalNew,
                    open: open,
                    title: "Ticket Verification Fail",
                    subtitle: "Ticket-Verify",
                    description: "",
                    modalType: "Ticket-Verify",
                    button: "Confirm",
                    Data: tickets_response
                });

                setTicketDetails({
                    ...TicketDetails,
                    afs_issue: "",
                    afs_issue_type: "",
                    afs_product_name: "",
                });
            };
        };
    }, [ tickets_response ]);

    // RESET VERIFIED TICKETS DATA
    const ResetVerifyTickets = () => {
        dispatch(StartMainCommonLoader({
            url: "",
            loader: false
        }));
        setMainState({
            ...MainState,
            ticket_number: "",
        });
        setTicketDetails({
            ...TicketDetails,
            afs_issue: "",
            afs_issue_type: "",
            afs_product_name: "",
        });
        dispatch(TicketsVerfiyAPI({}));
    };

    const handleKeyPress = (e) => {
        // Allow only digits (0-9)
        const charCode = e.which || e.keyCode;
        if (charCode < 48 || charCode > 57) {
          e.preventDefault();
        };
    };

    return (<>
        <div className="col-md-4">
            <Form.Group className="mb-3 " >
                <Form.Label>Ticket Number {isMendatory && (<span className="mendatory_star">*</span>)}</Form.Label>
                <div className="verify_tickets_wrapper">
                    <div className="verify_wrapper">
                        <Form.Control 
                            type="number" 
                            value={ticket_number} 
                            onChange={(e) => setMainState({...MainState, ticket_number: e.target.value})}
                            onKeyUp={(e) => CheckValid(e.target.value, {type: 'ticket_number', error: seterror_tickets_number})}
                            onKeyDown={(e) => {
                                exceptThisCostSymbols.includes(e.key) && e.preventDefault()
                                EmptySpaceFieldValid(e);
                                onEnterInvoiceSearch(e);
                            }}
                            onKeyPress={handleKeyPress}
                            className="inputBoxs"
                            disabled={(commonMainLoader?.url === "ticket_search_by_ticket_number" && commonMainLoader?.loader) || Object?.keys(tickets_response)?.length > 0}
                            placeholder="Enter Ticket Number" 
                            maxLength={3}
                            min="1" 
                            max="10"
                        />
                        {(commonMainLoader?.url === "ticket_search_by_ticket_number" && commonMainLoader?.loader) && (<div className="verify_loader">
                            <Spinner />
                        </div>)}
                    </div>
                    <div className="verify_tickets_wrapper_btns">
                        <Button className="btn verify_tickets_btn" onClick={() => VerifyTickets()} disabled={(commonMainLoader?.url === "ticket_search_by_ticket_number" && commonMainLoader?.loader) || tickets_response?.status === "SUCCESS"} >
                            Verify
                        </Button>
                        <Button className="btn reset_btn" onClick={() => ResetVerifyTickets()} >
                            Reset
                        </Button>
                    </div>
                </div>
                {isMendatory && (<React.Fragment>
                    {error_tickets_number !== "" && (<span className="error_medotory">{error_tickets_number}</span>)}
                </React.Fragment>)}
            </Form.Group>
        </div>
        <div className="col-md-4">
            <Form.Group className="mb-3 " >
                <Form.Label>{TicketDetailsLabel} Issue</Form.Label>
                <div className="defaultvalueField">
                    {TicketDetails?.afs_issue === null ? "NA" : TicketDetails?.afs_issue}
                </div>
            </Form.Group>
        </div>
        <div className="col-md-4">
            <Form.Group className="mb-3 " >
                <Form.Label>{TicketDetailsLabel} Issue Type</Form.Label>
                <div className="defaultvalueField">
                    {TicketDetails?.afs_issue_type === null ? "NA" : TicketDetails?.afs_issue_type}
                </div>
            </Form.Group>
        </div>
        <div className="col-md-4">
            <Form.Group className="mb-3 " >
                <Form.Label>{TicketDetailsLabel} Product Name</Form.Label>
                <div className="defaultvalueField">
                    {(TicketDetails?.afs_product_name === null || TicketDetails?.afs_product_name === undefined) ? "NA" : TicketDetails?.afs_product_name}
                </div>
            </Form.Group>
        </div>
    </>);
};

export default TicketsVerify;